import React, { PureComponent } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

type ModalProps = {
  title: string;
  body1: string;
  body2: string;
  primaryActionLabel: string;
  secondaryActionLabel: string;
  primaryAction: () => void;
  secondaryAction: () => void;
};

type ModalState = {
  show: boolean;
};

export default class CustomModal extends PureComponent<ModalProps, ModalState> {
  state = {
    show: true,
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  primaryAction = () => {
    const { primaryAction } = this.props;
    this.setState({ show: false });
    setTimeout(primaryAction, 300);
  };

  secondaryAction = () => {
    const { secondaryAction } = this.props;
    this.setState({ show: false });
    setTimeout(secondaryAction, 300);
  };

  render() {
    const { title, body1, body2, primaryActionLabel, secondaryActionLabel } = this.props;

    const { show } = this.state;

    return (
      <Modal show={show} onHide={this.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{body1}</p>
          <p>{body2}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={this.primaryAction}>
            {primaryActionLabel}
          </Button>
          <Button variant="secondary" onClick={this.secondaryAction}>
            {secondaryActionLabel}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
